<template>

  <yams-template v-show="this.showButtons">
    <template #header>
      <div class="mr-5">
        <h4 class="text-primary font-weight-bold">Demandes > #DEA0{{ this.$route.params.id }}</h4>
      </div>
      <div class="mr-4">
        <NavOperations></NavOperations>
      </div>
    </template>
    <template #content>
      <div class="container">
        <a href="#retour-liste" class="btn btn-sm btn-secondary mb-3" @click.prevent="$router.push({name: 'reservations'})">
          <i class="fas fa-chevron-left mr-1"></i> Retour
        </a>

        <div v-show="!editMode">
          <InvoiceRenderer :key="key" :showButtons="showButtons" :invoice="invoice" :options="invoiceOptions"
            @edit-invoice="openEditMode" @print-invoice="printInvoice" />
        </div>

        <div v-show="editMode">
          <InvoiceEditorReservation :key="key" :libelle="invoice.items[0]?.title" :qte="invoice.items[0]?.qty"
            :montant="invoice.items[0]?.totalPrice" @update-ligne="updateLine" />
        </div>
        <div v-if="reservation && reservation.statut == 'Brouillon'">
          <payment-button  :key="key" :demande="reservation"></payment-button>
        </div>
        
      </div>
    </template>
  </yams-template>

  <div v-show="!this.showButtons" class="container">
    <InvoiceRenderer :key="key" :showButtons="showButtons" :invoice="invoice" :options="invoiceOptions"
      @edit-invoice="openEditMode" @print-invoice="printInvoice" />
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import NavOperations from '@/views/operations/NavOperations.vue';
import InvoiceEditorReservation from './InvoiceEditorReservation.vue';
import PaymentButton from '@/components/PaymentButton.vue'

export default defineComponent({
  components: { NavOperations, InvoiceEditorReservation, PaymentButton},
  data() {
    return {
      isLoading: false,
      reservation: null,
      trajetLibelle: '',
      key: 1,
      invoice: {
        seller: {
          name: 'YAM\'S Logistics',
          logo: 'https://logistics.yams-ga.com/images/logo.png',
          website: 'https://yamslogistics.com',
          email: 'infos@yamslogistics.com',
          phone: '+241 060 47 65 20',
          signature: '/img/yams-cachet.png'
        },
        client: {
          name: this.$store.getters.user.nom + ' ' + this.$store.getters.user.prenom,
          address: this.$store.getters.user.adresse,
          postalCode: this.$store.getters.user.bp,
          phone: this.$store.getters.user.telephone1
        },
        items: [],
        description: [],
        taxes: {
          tva: 18,
          tps: 0,
          css: 2
        },
        issued_at: '2025-07-10',
        due_at: '2025-07-17',
        number: 'DEA',
        type: 'proforma',
        status: 'Brouillon'
      },
      invoiceOptions: {
        showTaxes: true,
        useTVA: false,
        useTPS: false,
        useCSS: false,
        currency: 'XAF',
        locale: 'fr'
      },
      editMode: false,
      showButtons: true
    }
  },
  mounted() {
    this.showDevis()
  },
  methods: {
    openEditMode() {
      this.editMode = true
    },
    handleSave(updatedInvoice) {
      this.invoice = updatedInvoice.invoice
      this.invoiceOptions = updatedInvoice.options
      this.editMode = false
      this.key++
    },
    printInvoice() {
      this.showButtons = false
      this.$nextTick(() => {
        window.print()
        setTimeout(() => (this.showButtons = true), 1000)
      })
    },
    showDevis() {
      const reservationId = this.$route.params.id

      this.axios.get(`/api/demandes/${reservationId}`)
        .then(response => {
          const reservation = response.data.data
          this.reservation = reservation

          if (reservation.invoice) {
            this.invoice.items = reservation.invoice
          } else {
            this.invoice.items = [{
              title: 'Location ' + reservation.type_vehicule + ' au depart de ' + reservation.ville_chargement + ' pour ' + reservation.ville_dechargement,
              qty: 1,
              price: reservation.montant,
              totalPrice: reservation.montant
            }]
          }


          this.invoice.number = 'DEA0' + reservation.id
          this.invoice.status = reservation.statut
          this.invoice.issued_at = this.$dateFormat(reservation.created_at)
          this.invoice.due_at = this.$dateFormat(reservation.created_at)
          this.key++
          console.log('teste', this.invoice.items)
        })
        .catch(error => {
          console.error("Erreur lors de la récupération de la réservation :", error)
        })
    },
    updateLine(data) {
      this.isLoading = true
      const invoiceItems = [{
        title: data.libelle,
        qty: data.qte,
        price: data.price,
        totalPrice: data.totalPrice
      }]

      const form = {
        'invoice': invoiceItems,
        'montant': invoiceItems.reduce((acc, item) => acc + item.qty * item.price, 0)
      }
      this.axios.post('/api/demandes/' + this.$route.params.id + '/update', form).then((response) => {
        this.isLoading = false
        if (response.data.success === true) {
          this.editMode = false
          this.invoice.items = invoiceItems
          this.key++
          this.$toast.add({
            severity: 'success',
            detail: response.data.message,
            life: 3000
          });
        }
        else {
          response.data.errors.forEach(element => {
            this.$toast.add({
              severity: 'warn',
              summary: 'Oups !',
              detail: element,
              life: 7000
            });
          });
        }
      }).catch(() => {
        this.isLoading = false
        this.$toast.add({
          severity: 'error',
          summary: 'Probleme de connexion',
          detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
          life: 5000
        });
      })
    }
  }
})
</script>